interface AdminPageProps {
  eyebrow?: string;
  title: string;
  description?: string;
  action?: React.ReactNode;
  children: React.ReactNode;
}

/** Standard admin page chrome: title block + body. Narrower than PainelPage
 *  because the sidebar already gives identity, and wider tables benefit from
 *  more horizontal room. */
export function AdminPage({
  eyebrow,
  title,
  description,
  action,
  children,
}: AdminPageProps) {
  return (
    <div className="mx-auto w-full max-w-7xl px-3 py-6 sm:px-8 sm:py-10">
      <header className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between sm:gap-8">
        <div>
          {eyebrow && (
            <p className="text-[11px] font-medium uppercase tracking-[0.22em] text-text-tertiary">
              {eyebrow}
            </p>
          )}
          <h1
            className="font-semibold leading-[1.05] tracking-[-0.025em] text-text"
            style={{ fontSize: "clamp(1.5rem, 2.2vw, 1.875rem)", marginTop: eyebrow ? "0.5rem" : 0 }}
          >
            {title}
          </h1>
          {description && (
            <p className="mt-2 max-w-2xl text-sm leading-relaxed text-text-secondary">
              {description}
            </p>
          )}
        </div>
        {action && <div className="shrink-0">{action}</div>}
      </header>

      <div className="mt-8">{children}</div>
    </div>
  );
}
